import { render, staticRenderFns } from "./event_detail.vue?vue&type=template&id=3d463da0&scoped=true&lang=pug&"
import script from "./event_detail.vue?vue&type=script&lang=js&"
export * from "./event_detail.vue?vue&type=script&lang=js&"
import style0 from "./event_detail.vue?vue&type=style&index=0&id=3d463da0&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d463da0",
  null
  
)

export default component.exports